<div [ngClass]="['cell', resourcesCssService.responsiveClass()]">
  <div class='expander'>
    <button class="more-button" (click)='toggleExpanded()'><i [ngClass]='moreButtonClass()'></i></button>
  </div>
  <div class='info'>
    <h2 class='title'>{{ pem.name }}</h2>
    <div [ngClass]='{description: true, expanded: isExpanded}' [innerHTML]="pem.description"></div>
    <!-- <p class='types'>{{ pem.pemTypes | concat:" • " }}</p> -->
  </div>
</div>